import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field } from "redux-form";
import moment from "moment";
import { renderSingleCheckbox } from "@basecomponent";
import {
  convertUTCDateIntoLocalDate,
  displayDateInBrowserFormat,
} from "@datehandle";
import LocaleStrings from "@language";

const SessionRSVP = (props) => {
  let { formValues, RSVPSessionsData, eventSettingsData, eventData } = props;
  let showGlobalTime = eventData?.showconvertedtimezone ?? false; // true/flase, check if global timezone is enabled, then display local time, else time as per event
  let multipleRSVP = eventSettingsData?.rsvpmultiple ?? true; // true/false, check the multiple RSVP allowed of common time sessions
  let restrictRSVPPerTrack = JSON.parse(
    eventSettingsData?.session_settings ?? "{}"
  )?.single_rsvp_per_track; // true/false , check the restrict attendees to mark rsvp more than one sessions per track
  let rsvpsessions = formValues?.rsvpsessions ?? [];
  // console.log("formValues :- ", formValues);
  // console.log("RSVPSessionsData :- ", RSVPSessionsData);

  const handleRSVPSession = (id) => {
    if (rsvpsessions?.length > 0) {
      let index = rsvpsessions.indexOf(id);
      if (index > -1) {
        rsvpsessions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        rsvpsessions.push(id);
      }
    } else {
      rsvpsessions.push(id);
    }

    props.autofill("rsvpsessions", rsvpsessions);
  };

  const checkOverlapping = (stime, etime, trackname) => {
    let mutiplersvp = false;
    let multiplepertrack = false;
    let revpSessions = [];
    RSVPSessionsData?.map((obj) => {
      let sessionid = obj?.sessionid;
      let index = rsvpsessions.indexOf(sessionid);
      if (index > -1) {
        revpSessions.push(obj);
      }
    });
    if (!multipleRSVP) {
      let match = revpSessions.filter((obj) => {
        return (
          (moment(stime).unix() >= moment(obj?.starttime).unix() &&
            moment(stime).unix() < moment(obj?.endtime).unix()) ||
          (moment(etime).unix() > moment(obj?.starttime).unix() &&
            moment(etime).unix() <= moment(obj?.endtime).unix()) ||
          (moment(stime).unix() < moment(obj?.starttime).unix() &&
            moment(etime).unix() > moment(obj?.endtime).unix())
        );
      });

      mutiplersvp = match?.length > 0;
    }
    if (restrictRSVPPerTrack) {
      let match = revpSessions.filter((obj) => {
        return trackname == obj?.trackname;
      });
      multiplepertrack = match?.length > 0;
    }
    return mutiplersvp || multiplepertrack;
  };
  // console.log("RSVPSessionsData :- ", RSVPSessionsData);

  let lastDisplayedDate = "";

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {RSVPSessionsData?.map((obj, i) => {
          let sessionid = obj?.sessionid;
          let capacity = obj?.capacity;
          let totalRSVP = obj?.totalrsvpcount;
          let stime = moment(obj?.starttime);
          let etime = moment(obj?.endtime);
          let priColor = obj?.primarytextcolor
            ? obj?.primarytextcolor.trim()
            : "";
          let secColor = obj?.secondarytextcolor
            ? obj?.secondarytextcolor.trim()
            : "";
          let bgColor = obj?.backgroundcolor ? obj?.backgroundcolor.trim() : "";
          let borderColor = obj?.bordercolor ? obj?.bordercolor.trim() : "";
          let track = obj.trackname;
          let currentDate = obj.scheduledate;

          let disabled = false;
          let seatFull = "";
          if (capacity > 0 && capacity === totalRSVP) {
            disabled = true;
            seatFull = LocaleStrings.kSessionFullText;
          } else {
            let index = rsvpsessions.indexOf(sessionid);
            if (index > -1) {
              disabled = false;
            } else {
              disabled = checkOverlapping(stime, etime, track); // logic to check current session is overlapping with already selected session or not
            }
          }
          let sessionTime = `${displayDateInBrowserFormat(
            obj?.starttime,
            "Pp"
          )} - ${displayDateInBrowserFormat(obj?.endtime, "p")}`;
          if (showGlobalTime) {
            sessionTime = `${convertUTCDateIntoLocalDate(
              obj?.starttime_gmt,
              "Pp"
            )} - ${convertUTCDateIntoLocalDate(obj?.endtime_gmt, "p")}`;
          }
          const dateJSX =
            lastDisplayedDate !== currentDate ? (
              <div className="custom-text-primary-lg-bold col-span-full">
                {moment(currentDate).format("MMMM Do, YYYY")}
              </div>
            ) : (
              ""
            );

          lastDisplayedDate = currentDate;

          return (
            <>
              {dateJSX}
              <div
                key={`key_session_${i}`}
                className="border border-default bg-white p-4 rounded-lg"
                style={{
                  backgroundColor: bgColor,
                  borderColor: borderColor,
                }}
              >
                <Field
                  name={`markrsvp[${i}]`}
                  htmllabel={`<div class="space-y-0.5">
                  <div class="custom-text-primary-md-normal" style="color:${priColor}">${
                    obj?.title
                  } ${
                    seatFull !== ""
                      ? `<span class="custom-text-theme-sm-bold ml-1" style="color:${priColor}">(${seatFull})</span>`
                      : ""
                  }</div>
                  <div class="custom-text-secondary-sm-medium">${
                    obj?.trackname && obj?.trackname !== "##NOTRACK##"
                      ? obj?.trackname
                      : ""
                  }</div>
                  ${
                    obj?.location
                      ? `<div class="custom-text-secondary-sm-normal custom-item-vcenter gap-1" style="color:${secColor}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                    </svg>
                    ${obj?.location}
                  </div>`
                      : ``
                  }
                  <div class="custom-text-secondary-sm-normal custom-item-vcenter gap-1" style="color:${secColor}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                    ${sessionTime}
                  </div>
                </div>`}
                  component={renderSingleCheckbox}
                  value={sessionid}
                  onChange={() => handleRSVPSession(sessionid)}
                  type="checkbox"
                  disabled={disabled}
                />
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return { eventData: state.eventData };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SessionRSVP);
